import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import { CloseRounded, WarningAmberRounded } from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";

const _CreditExpireModal = ({ open, onClose, onSubmit, submitting, userCredit }) => {
    if (!open || !userCredit) return null;

    return (
        <Dialog
            open={open}
            onClose={() => !submitting && onClose()}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 20px 45px rgba(0,0,0,0.12)',
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <WarningAmberRounded color="error" />
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>
                        منقضی‌سازی اعتبار
                    </Typography>
                </Box>
                <IconButton
                    size="small"
                    onClick={onClose}
                    disabled={submitting}
                >
                    <CloseRounded fontSize="small" />
                </IconButton>
            </DialogTitle>

            <Box component="form" onSubmit={onSubmit}>
                <DialogContent sx={{ pt: 1.5 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, lineHeight: 1.8 }}>
                        آیا از منقضی‌سازی دستی این بسته اعتباری برای کاربر اطمینان دارید؟
                    </Typography>

                    <Box
                        sx={{
                            p: 2,
                            borderRadius: 3,
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)',
                            border: '1px solid',
                            borderColor: 'divider',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="caption" color="text.secondary">عنوان بسته:</Typography>
                            <Typography variant="caption" sx={{ fontWeight: 800 }}>{userCredit.Name || "بدون نام"}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="caption" color="text.secondary">مبلغ باقیمانده:</Typography>
                            <Typography variant="caption" sx={{ fontWeight: 800, color: 'primary.main' }}>
                                {toPriceWithComma(userCredit.CreditAmount)} تومان
                            </Typography>
                        </Box>
                    </Box>

                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5, lineHeight: 1.6 }}>
                        💡 <strong>نکته:</strong> طبق قوانین سیستم، امکان تغییر مستقیم محدودیت‌های ورزش یا بخش‌های مصرف وجود ندارد؛ جهت تغییر قوانین مصرف، این اعتبار را منقضی نموده و یک اعتبار جدید صادر فرمایید.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ borderRadius: 2.5, px: 2.5, color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        type="submit"
                        disabled={submitting}
                        sx={{
                            borderRadius: 2.5,
                            px: 3,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(239, 68, 68, 0.25)',
                        }}
                    >
                        {submitting ? <CircularProgress size={20} color="inherit" /> : "منقضی شود"}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default _CreditExpireModal;
